var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-484 -175) translate(484 175) rotate(-90 8 8)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5L9.5 5",
    transform: "translate(-484 -175) translate(484 175) translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5L9.5 5",
    transform: "translate(-484 -175) translate(484 175) translate(3 3) rotate(90 5 5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16Plus);
export default __webpack_public_path__ + "static/media/ico16Plus.1254e012.svg";
export { ForwardRef as ReactComponent };